import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ToastProvider } from './context/ToastContext';
import { ComparisonProvider } from './context/ComparisonContext';
import { initializeAnalytics, trackPageView, trackConversionEvent } from './utils/analytics';
import Home from './pages/Home';
import SearchPage from './pages/SearchPage';
import PropertyDetailsPage from './pages/PropertyDetailsPage';
import AuthPage from './pages/Auth';
import SavedPage from './pages/SavedPage';
import ProtectedRoute from './components/ProtectedRoute';
import AuthCallback from './pages/AuthCallback';
import AuthPopup from './pages/AuthPopup';
import ScenarioAnalysisPage from './pages/ScenarioAnalysisPage';
import ComparisonPage from './pages/ComparisonPage';
import PortfolioPage from './pages/PortfolioPage';
import PortfolioPropertyDetailsPage from './pages/PortfolioPropertyDetailsPage';
import './App.css';

function App() {
    const location = useLocation();

    // Initialize analytics and track page views
    useEffect(() => {
        // Initialize analytics on app load
        initializeAnalytics();

        // Track initial page visit
        trackConversionEvent('visit');
    }, []);

    // Track page changes
    useEffect(() => {
        const path = location.pathname;
        const title = getPageTitle(path);
        trackPageView(path, title);
    }, [location]);

    // Helper function to get page titles
    const getPageTitle = (path) => {
        const titles = {
            '/': 'Home - Revest AI',
            '/search': 'Property Search - Revest AI',
            '/auth': 'Sign In/Sign Up - Revest AI',
            '/saved': 'Saved Properties - Revest AI',
            '/dashboard': 'Dashboard - Revest AI',
        };

        // Handle dynamic routes
        if (path.startsWith('/portfolio/')) {
            return 'Portfolio Property - Revest AI';
        }
        if (path === '/portfolio') {
            return 'My Portfolio - Revest AI';
        }
        if (path.startsWith('/properties/')) {
            return 'Property Details - Revest AI';
        }
        if (path.startsWith('/auth/')) {
            return 'Authentication - Revest AI';
        }

        return titles[path] || 'Revest AI';
    };

    return (
        <AuthProvider>
            <ToastProvider>
                <ComparisonProvider>
                <Routes>
                    {/* Public Pages */}
                    <Route path="/" element={<Home />} />
                    <Route path="/search" element={<SearchPage />} />
                    <Route path="/auth" element={<AuthPage />} />
                    <Route path="/auth/callback" element={<AuthCallback />} />
                    <Route path="/auth/popup" element={<AuthPopup />} />
                    <Route path="/properties/:id" element={<PropertyDetailsPage />} />

                    {/* Protected Pages */}
                    <Route
                        path="/scenarios/:id"
                        element={
                            <ProtectedRoute>
                                <ScenarioAnalysisPage />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/compare"
                        element={
                            <ProtectedRoute>
                                <ComparisonPage />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/portfolio"
                        element={
                            <ProtectedRoute>
                                <PortfolioPage />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/portfolio/:id"
                        element={
                            <ProtectedRoute>
                                <PortfolioPropertyDetailsPage />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/saved"
                        element={
                            <ProtectedRoute>
                                <SavedPage />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/dashboard"
                        element={
                            <ProtectedRoute>
                                <Home />
                            </ProtectedRoute>
                        }
                    />
                </Routes>
                </ComparisonProvider>
            </ToastProvider>
        </AuthProvider>
    );
}

export default App;